<template>
  <Popper
    trigger="click"
    :options="options"
  >
    <div class="popper popper-simple popper-arrow">
      <slot name="content" />
    </div>
    <a
      slot="reference"
      href="#"
      class="absolute pin-r pin-t pr-4 pt-4"
      @click.prevent=""
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="18"
        viewBox="0 0 6 27"
      >
        <g
          fill="#82848A"
          fill-rule="evenodd"
        >
          <circle
            cx="3"
            cy="3"
            r="3"
          />
          <circle
            cx="3"
            cy="13.5"
            r="3"
          />
          <circle
            cx="3"
            cy="24"
            r="3"
          />
        </g>
      </svg>
    </a>
  </Popper>
</template>

<script type="text/babel">
import Popper from 'vue-popperjs'

export default {
  name: 'DotPopper',
  components: {
    Popper,
  },
  props: {
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
}
</script>
